import { render, staticRenderFns } from "./SiteSettings.vue?vue&type=template&id=9b0d9848&scoped=true&"
import script from "./SiteSettings.vue?vue&type=script&lang=js&"
export * from "./SiteSettings.vue?vue&type=script&lang=js&"
import style0 from "./SiteSettings.vue?vue&type=style&index=0&id=9b0d9848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0d9848",
  null
  
)

export default component.exports